import { mapActions, mapGetters } from 'vuex'
import cabecalho from '@/components/global/Cabecalho/Cabecalho.vue'
import menuLateral from '@/components/global/MenuLateral/MenuLateral.vue'
import util from '@/util'
import mensagens from '@/util/mensagens'
import { BSpinner } from 'bootstrap-vue'

export default {
  name: 'PoliticaSeguranca',
  components: {
    cabecalho,
    menuLateral,
    'b-spinner': BSpinner
  },

  computed: {
    ...mapGetters('politicaSeguranca', ['flags', 'dadosRetorno', 'carregandoDados', 'manipulandoDados'])
  },

  data () {
    return {
      flagsLocais: null,
      configuracoesFlags: [
        {
          chave: 'senhas_fortes',
          titulo: 'Política de Senhas Fortes',
          descricao: 'Exige mínimo de 12 caracteres, letra maiúscula, número e caractere especial.'
        },
        {
          chave: 'expiracao_senha',
          titulo: 'Expiração Automática de Senha',
          descricao: 'A senha expira a cada 90 dias e o acesso fica bloqueado até a atualização.'
        },
        {
          chave: 'historico_senhas',
          titulo: 'Histórico de Senhas',
          descricao: 'Impede a reutilização das últimas 3 senhas cadastradas.'
        },
        {
          chave: 'autenticacao_2fa',
          titulo: 'Autenticação 2FA',
          descricao: 'Código de verificação obrigatório para todos os usuários, com revalidação a cada 30 dias.'
        },
        {
          chave: 'bloqueio_tentativas',
          titulo: 'Bloqueio por Tentativas Inválidas',
          descricao: 'Bloqueia o acesso por 15 minutos após 5 tentativas de login incorretas.'
        },
        {
          chave: 'expiracao_sessao',
          titulo: 'Expiração de Sessão',
          descricao: 'Encerra a sessão automaticamente após 30 minutos de inatividade.'
        }
      ]
    }
  },

  watch: {
    flags (novasFlags) {
      if (novasFlags) {
        this.flagsLocais = { ...novasFlags }
      }
    }
  },

  async created () {
    await this.ActionObterPoliticaSeguranca()
  },

  beforeDestroy () {
    this.ActionResetarDadosRetornoCadastro()
  },

  methods: {
    ...mapActions('politicaSeguranca', ['ActionSalvarPoliticaSeguranca', 'ActionObterPoliticaSeguranca', 'ActionResetarDadosRetornoCadastro']),

    async salvar () {
      try {
        await this.ActionSalvarPoliticaSeguranca(this.flagsLocais)
        await this.tratarAposSalvarRegistro()
      } catch (erro) {
        util.criarAlertaToastDeErro(this, 'Erro', mensagens.falhaServidorSalvandoDados)
      }
    },

    async tratarAposSalvarRegistro () {
      if (this.dadosRetorno.sucesso) {
        util.criarAlertaToastDeSucesso(this, 'Aviso', 'Política de segurança salva com sucesso.')
      } else {
        util.criarAlertaToastDeErro(this, 'Aviso', this.dadosRetorno.mensagem)
      }
    }
  }
}
